import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs';
import { QuickQuote, QuickQuoteResults } from '@data/schema';
import { QuickQuoteResultsRoot } from '@data/schema/quick-quote-results-root';
import { transaction } from '@data/schema/quote-constants';
import {InviteBorrower} from "@data/schema/invite-borrower";
import {ResultRates} from "@data/schema/ResultRates";
import {LPProducts} from "@data/schema/LPProducts";
import {WebStorageService} from 'ngx-web-storage';
import {OktaClaims} from '@data/schema/OktaClaims';
import {CompanyInfo} from '@data/schema/company/company-info';
@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  private quickQuote: BehaviorSubject<QuickQuote>;
  private quickQuoteResults: BehaviorSubject<QuickQuoteResults>;
  private quickQuoteResultsRoot: BehaviorSubject<QuickQuoteResultsRoot>;
  private newLoanResponse: BehaviorSubject<InviteBorrower>;
  private lp_qq_results : ResultRates;
  private selectedRateGridId : string;
  private selectedCriteriaKey : string;
  private selectedProduct : BehaviorSubject<LPProducts>;
  private progress_percentage: number ;
  states = ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado',
    'Connecticut', 'Delaware', 'District Of Columbia', 'Federated States Of Micronesia', 'Florida', 'Georgia',
    'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine',
    'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana',
    'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
    'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island',
    'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Islands', 'Virginia',
    'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
  claims : OktaClaims;
  globalQQ: QuickQuote;
  constructor(private storage: WebStorageService) {
    this.quickQuote = new BehaviorSubject<QuickQuote>(
      JSON.parse(localStorage.getItem('quickQuote'))
    );
    this.quickQuoteResults = new BehaviorSubject<QuickQuoteResults>(
      JSON.parse(localStorage.getItem('quickQuoteResults'))
    );
    this.quickQuoteResultsRoot = new BehaviorSubject<QuickQuoteResultsRoot>(
      JSON.parse(localStorage.getItem('quickQuoteResultsRoot'))
    );
    this.newLoanResponse = new BehaviorSubject<InviteBorrower>(
      JSON.parse(localStorage.getItem('newLoanResponse'))
    );
    this.lp_qq_results =  JSON.parse(localStorage.getItem('lp_qq_results'));
    this.selectedRateGridId =  JSON.parse(localStorage.getItem('selectedRateGridId'));
    this.selectedCriteriaKey =  JSON.parse(localStorage.getItem('selectedCriteriaKey'));
    this.progress_percentage = JSON.parse(localStorage.getItem('progress_percentage'));
  }
  setCompanyInfo(companyInfo: CompanyInfo) {
    sessionStorage.setItem('company-info', JSON.stringify(companyInfo));
  }
  getCompanyInfo() {
    return JSON.parse(sessionStorage.getItem('company-info'));
  }
  setProgressPercentage(progressPercent: number) {
    localStorage.setItem('progress_percentage', JSON.stringify(progressPercent));
  }
  getProgressPercentage() {
    return JSON.parse(localStorage.getItem('progress_percentage'));
  }
  setSelectedProduct(selectedProduct: LPProducts) {
    localStorage.setItem('selected_product', JSON.stringify(selectedProduct));
  }
  getSelectedProduct() :LPProducts {
    return JSON.parse(localStorage.getItem('selected_product'));
  }
  setSelectedRateGridId(selectedRateGridId: string) {
    localStorage.setItem('selectedRateGridId', JSON.stringify(selectedRateGridId));
  }
  setSelectedCriteriaKey(selectedCriteriaKey: string) {
    localStorage.setItem('selectedCriteriaKey', JSON.stringify(selectedCriteriaKey));
  }
  getSelectedRateGridId(): string {
     return JSON.parse(localStorage.getItem('selectedRateGridId'));
  }
  getSelectedCriteriaKey(): string {
    return JSON.parse(localStorage.getItem('selectedCriteriaKey'));
  }
  setLPQQResults(lp_qq_results: ResultRates) {
    localStorage.setItem('lp_qq_results', JSON.stringify(lp_qq_results));
  }
  getLPQQResults(): ResultRates {
    return JSON.parse(localStorage.getItem('lp_qq_results')) ;
  }

  setQuickQuote(quickQuote: QuickQuote) {
    this.quickQuote.next(quickQuote);
    localStorage.setItem('quickQuote', JSON.stringify(this.quickQuote.value));
  }

  getQuickQuote(): Observable<QuickQuote> {
    if (JSON.parse(localStorage.getItem('quickQuote')) == null) {
      this.quickQuote = new BehaviorSubject<QuickQuote>(new QuickQuote());
    }
    return this.quickQuote;
  }

  setQuickQuoteResults(quickQuoteResults: QuickQuoteResults) {
    this.quickQuoteResults.next(quickQuoteResults);
    localStorage.setItem(
      'quickQuoteResults',
      JSON.stringify(this.quickQuoteResults.value)
    );
  }
  clearQuickQuoteStorage() {
    localStorage.removeItem('quickQuote');
    localStorage.removeItem('quickQuoteResultsRoot');
    localStorage.removeItem('newLoanResponse');
    localStorage.removeItem('quickQuoteResults');
  }

  setNewLoanResponse(newLoanResponse: InviteBorrower) {
    this.newLoanResponse.next(newLoanResponse);
    localStorage.setItem(
      'newLoanResponse',
      JSON.stringify(this.newLoanResponse.value)
    );
  }
  getNewLoanResponse(): Observable<InviteBorrower> {
    if (JSON.parse(localStorage.getItem('newLoanResponse')) == null) {
      this.newLoanResponse = new BehaviorSubject<InviteBorrower>(
        new InviteBorrower(1,1,null,'')
      );
    }
    return this.newLoanResponse;
  }

  setQuickQuoteResultsRoot(quickQuoteResultsRoot: QuickQuoteResultsRoot) {
    this.quickQuoteResultsRoot.next(quickQuoteResultsRoot);
    localStorage.setItem(
      'quickQuoteResultsRoot',
      JSON.stringify(this.quickQuoteResultsRoot.value)
    );
  }
  getQuickQuoteResultsRoot(): Observable<QuickQuoteResultsRoot> {
    if (JSON.parse(localStorage.getItem('quickQuoteResultsRoot')) == null) {
      this.quickQuoteResultsRoot = new BehaviorSubject<QuickQuoteResultsRoot>(
        new QuickQuoteResultsRoot()
      );
    }
    return this.quickQuoteResultsRoot;
  }

  getQuickQuoteResults(): Observable<QuickQuoteResults> {
    if (JSON.parse(localStorage.getItem('quickQuoteResults')) == null) {
      this.quickQuoteResults = new BehaviorSubject<QuickQuoteResults>(
        new QuickQuoteResults()
      );
    }
    return this.quickQuoteResults;
  }

  isMIMandatory(): boolean {
    this.getQuickQuote().subscribe(quickQuote => {
      this.globalQQ = quickQuote;
    });
    if (
      (this.globalQQ.transactionType === transaction.PURCHASE &&
        (this.globalQQ.govtLoan || this.globalQQ.loanToValue <= 80)) ||
      (this.globalQQ.loanToValue <= 80 &&
        (this.globalQQ.transactionType === transaction.REFINANCE ||
          this.globalQQ.transactionType === transaction.REFINANCE_CASH_OUT))
    ) {
      return false;
    } else return true;
  }
  isTaxAndEscrowsMandatory(): boolean {
    this.getQuickQuote().subscribe(quickQuote => {
      this.globalQQ = quickQuote;
    });
    if (this.globalQQ.loanToValue <= 80) {
      return true;
    } else return false;
  }
  getClaims(): OktaClaims{
   return this.storage.local.get("user-claims");
  }
  getStates(){
    return this.states;
  }

}
